var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"indexPage"},[_c('main',{staticClass:"indexPage__main"},[_c('FormSignIn')],1),_c('PageFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }